var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 1.27532C7.68342 0.884791 8.31658 0.884791 8.70711 1.27532L15.7071 8.27532C16.0976 8.66584 16.0976 9.299 15.7071 9.68953C15.3166 10.0801 14.6834 10.0801 14.2929 9.68953L8 3.39664L1.70711 9.68953C1.31658 10.0801 0.683417 10.0801 0.292893 9.68953C-0.0976311 9.299 -0.0976311 8.66584 0.292893 8.27532L7.29289 1.27532Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUp);
export default __webpack_public_path__ + "static/media/icArrowUp.da2bd0535f27bd6337c95d27713b2c8f.svg";
export { ForwardRef as ReactComponent };